/* Ombrail — motion v24 (session Motion, 26.09.2026)
   Apparitions au défilement : seuls les blocs encore sous l'écran au chargement sont concernés.
   Sans ce script, ou avec « réduire les animations », tout reste affiché normalement. */
(function(){
  var w=window,d=document,h=d.documentElement;
  if(!('IntersectionObserver' in w)||w.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var main=d.querySelector('main'); if(!main) return;

  // Grilles dont les enfants apparaissent l'un après l'autre
  var GROUPS='.oh-grid,.oh-categories__grid,.o-collection__grid,.o-search__grid,.o-pairs,.o-stones__grid,.o-stories-grid,.o-edit-shop__columns,.o-collections__grid,.o-collections__stones,.o-information-blocks,.o-collection__help,.o-faq__questions,.o-guides__list';
  // Blocs qui apparaissent d'un seul tenant (rangées défilantes : pas d'animation carte par carte)
  var SINGLES='.oh-shop__list,.oh-room2__stage,.oh-room2__panel,.oh-palette__panel,.o-product-discovery__grid,.o-stone,.o-pdp-details__story';
  var SKIP='dialog,[hidden],.oh-hero,.o-hero,.o-collection__seo-text,.o-guide__body';
  var list=[];
  function add(el){
    if(!el||el.closest(SKIP)) return;
    for(var i=0;i<list.length;i++){ if(list[i]===el||list[i].contains(el)||el.contains(list[i])) return; }
    list.push(el);
  }
  main.querySelectorAll(GROUPS).forEach(function(g){
    for(var c=g.firstElementChild;c;c=c.nextElementSibling){ if(!/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(c.tagName)) add(c); }
  });
  main.querySelectorAll(SINGLES).forEach(add);
  // Titres de section (h2 d'affichage) avec leur surtitre ou leur phrase d'appui
  main.querySelectorAll('h2').forEach(function(t){
    if(parseFloat(getComputedStyle(t).fontSize)<26) return;
    var p=t.parentElement;
    add(p&&p!==main&&p.children.length<=3&&p.offsetHeight<280?p:t);
  });
  if(!list.length) return;
  h.classList.add('om-motion');

  function done(t){ t.classList.remove('om-r','om-in'); t.style.removeProperty('--om-i'); }
  var seen=new WeakSet();
  var io=new IntersectionObserver(function(es){
    var n=0;
    es.forEach(function(e){
      var t=e.target,r=e.boundingClientRect;
      if(!seen.has(t)){
        seen.add(t);
        // Déjà visible, déjà dépassé ou non affiché : on ne touche à rien
        if(r.top<w.innerHeight||(!r.width&&!r.height)){ io.unobserve(t); return; }
        t.classList.add('om-r'); return;
      }
      if(!e.isIntersecting) return;
      io.unobserve(t);
      t.style.setProperty('--om-i',Math.min(n++,5));
      t.classList.add('om-in');
      var end=function(ev){ if(ev&&ev.target!==t) return; t.removeEventListener('transitionend',end); done(t); };
      t.addEventListener('transitionend',end);
      setTimeout(end,1600);
    });
  },{rootMargin:'0px 0px -40px 0px'});
  list.forEach(function(t){ io.observe(t); });

  // Impression ou retour arrière depuis le cache : tout afficher
  function all(){ list.forEach(done); io.disconnect(); }
  w.addEventListener('beforeprint',all);
  w.addEventListener('pageshow',function(e){ if(e.persisted) all(); });

  // Pulsation des points du salon en pause hors de l'écran
  var room=d.querySelector('.oh-room2');
  if(room) new IntersectionObserver(function(es){ room.classList.toggle('om-idle',!es[0].isIntersecting); }).observe(room);
})();

/* v25 (27.09): cart feedback. Watches the header cart counts; when one goes up, the cart link gets .om-bump
   for a moment (the animation itself lives in ombrail-motion.css, behind prefers-reduced-motion). */
(function(){if(!("MutationObserver"in window))return;document.querySelectorAll(".o-head__cart [data-o-badge]").forEach(function(b){var prev=parseInt(b.textContent,10)||0,link=b.closest(".o-head__cart");new MutationObserver(function(){var n=parseInt(b.textContent,10)||0;if(n>prev&&link){link.classList.remove("om-bump");void link.offsetWidth;link.classList.add("om-bump");clearTimeout(link._omBump);link._omBump=setTimeout(function(){link.classList.remove("om-bump")},900)}prev=n}).observe(b,{childList:true,characterData:true,subtree:true})})})();
